// extracted by mini-css-extract-plugin
var _1 = "cVYOlFP7N_FIeNKj8qFg";
export { _1 as "readOnlyView" }
